export default {
	name: "order-documents-modal",
	props: ["orderId", "heading", "modalId", "showModal", "orderTypeId", "orderStatusId"],
	emits: ["closeModal"],
	data() {
		return {
			documents: [],
			documentsHeadings: [
				{
					text: "File Name",
					field: "name"
				},
				{
					text: "Document Type",
					field: "documentType"
				}
			],
			documentTypes: [],
			modalHeading: null,
			modalComponentId: null,
			loading: false,
			documentToUpload:{
				documentTypeId: {
					value: null,
					errorMessage: null
				},
				file: {
					value : null,
					errorMessage: null
				}
			},
			showSuccessMessage: false,
			successMessage: null,
			showErrorMessage: false,
			errorMessage: null,
		};
	},
	methods: {
		getDocuments(){
			this.loading = true;
			orderService.getDocumentsByOrderId(this.orderId).then(
				successResponse => {
					let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
					if(isSuccess) {
						this.documents = successResponse.data.result;
					}
					this.loading = false;
				},
				errorResponse => {
					this.loading = false;
					apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
				}
			);
		},
		getDocumentTypesByOrderTypeId(){
			this.loading = true;
			orderService.getDocumentTypesByOrderTypeId(this.orderTypeId).then(
				successResponse => {
					let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
					if(isSuccess) {
						this.documentTypes = successResponse.data.result;
						this.documentTypes = $.map(this.documentTypes,
							function (obj) {
								obj.id = obj.id || obj.documentTypeId;
								obj.text = obj.text || obj.documentTypeName;
								return obj;
							});
                        // only show invoice document type if order status is pending invoice
                        if(this.orderStatusId !== orderHelper.orderStatus.pendingInvoice){
                            this.documentTypes = this.documentTypes.filter(function(docType){
                                return docType.text.toLowerCase() !== "invoice";
                            });
                        }
					}
					this.loading = false;
				},
				errorResponse => {
					this.loading = false;
					apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
				}
			);
		},
		onDocumentTypeSelect(documentType){
			this.documentToUpload.documentTypeId.value = documentType.id;
		},
		onDocumentAttach(event){
			this.documentToUpload.file.value = event.target.files[0];
		},
		onUploadClick(){
			var hasError = false;
			this.showErrorMessage = false;
			this.showSuccessMessage = false;
			this.documentToUpload.documentTypeId.errorMessage = null;
			this.documentToUpload.file.errorMessage = null;
			if(this.documentToUpload.documentTypeId.value === null){
				this.documentToUpload.documentTypeId.errorMessage = "Please select document type";
				hasError = true;
			}
			if(this.documentToUpload.file.value === null) {
				this.documentToUpload.file.errorMessage = "Please select file to upload";
				hasError = true;
			}
			if(hasError) {
				return;
			}
			this.loading = true;
			let request = {
				documentId: 0,
				orderId: this.orderId,
				documentTypeId: this.documentToUpload.documentTypeId.value,
				orderTypeId: this.orderTypeId,
			};
			var formData = new FormData();
			formData.append("file", this.documentToUpload.file.value);
			formData.append("request", JSON.stringify(request));
			orderService.addOrUpdateDocument(formData).then(
				successResponse => {
					let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
					if(isSuccess) {
						this.showSuccessMessage = true;
						this.successMessage = "Document uploaded successfully";
						this.documentToUpload.documentTypeId.value = null;
						this.documentToUpload.file.value = null;
						this.getDocuments();
					}
					else{
						this.showErrorMessage = true;
						this.errorMessage = successResponse.data.message;
					}
					this.loading = false;
				},
				errorResponse => {
					this.loading = false;
					apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
				}
			);
		},
		downloadDocument(documentId){
			this.loading = true;
			console.log("documents", this.documents);
			var selectedDocument = this.documents.find((doc) => doc.documentId === documentId);
			console.log("document", selectedDocument);
			let request = {
				pathToFileStorage: selectedDocument.pathInFileStorage,
				fileName: selectedDocument.name
			};
			orderService.downloadOrderDocument(request).then(
				successResponse => {
					console.log("successResponse", successResponse);
					const url = window.URL.createObjectURL(new Blob([successResponse.data]));
					const link = document.createElement('a');
					link.href = url;
					link.setAttribute('download', selectedDocument.name);
					document.body.appendChild(link);
					link.click();
					this.loading = false;
				},
				errorResponse => {
					console.log("errorResponse", errorResponse);
					this.loading = false;
					apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
				}
			);
		},
		errorMessageCloseClick(){
			this.showErrorMessage = false;
		},
		onSuccessMessageCloseClick(){
			this.showSuccessMessage = false;
		},
		onModalCloseClick(){
			console.log("close clicked");
			this.showErrorMessage = false;
			this.showSuccessMessage = false;
			this.documentToUpload.documentTypeId.errorMessage = null;
			this.documentToUpload.file.errorMessage = null;
			this.$emit("closeModal");
		}
	},
	mounted: function () {
		
	},
	watch: {
		orderId:{
			handler: function () {
				if (this.orderId) {
					this.getDocuments();
				}
			},
			immediate: true,
			deep: true
		},
		orderTypeId:{
			handler: function () {
				if (this.orderTypeId !== null && this.orderTypeId > 0) {
					this.getDocumentTypesByOrderTypeId();
				}
			},
			immediate: true,
			deep: true
		},
		heading: {
			handler: function () {
				if (this.heading) {
					this.modalHeading = this.heading;
				}
			},
			immediate: true,
			deep: true
		},
		modalId: {
			handler: function () {
				if (this.modalId) {
					this.modalComponentId = this.modalId;
				}
			},
			immediate: true,
			deep: true
		},
		showModal: {
			handler: function () {
				console.log("showModal", this.showModal);
				console.log("modalComponentId", this.modalComponentId);
				if (this.showModal) {
					//$("#" + this.modalId).modal("show");
					$("#" + this.modalComponentId).modal({
						keyboard: false,
						backdrop: 'static',
						show: true
					});
				} else {
					$("#" + this.modalComponentId).modal("hide");
				}
			},
			immediate: true,
			deep: true
		}
	}
};